import { lazy } from 'react';

export const SalesPage = lazy(() => import('./SalesPage'));
export const SalesSettingsPage = lazy(() => import('./SalesSettingsPage'));
